__turbopack_context__.v({
  "icon-actions": "clp-icon-secondary-actions-module-scss-module__FHXZ3W__icon-actions",
  "secondary-action-container": "clp-icon-secondary-actions-module-scss-module__FHXZ3W__secondary-action-container",
});
